import casamento from '@/assets/icons/habilitacao_casamento.svg?sprite'
import maternidade from '@/assets/icons/desc_maternidade.svg?sprite'
import obito from '@/assets/icons/desc_obito.svg?sprite'
import reg from '@/assets/icons/reg.svg?sprite'
import dnv from '@/assets/icons/dnv.svg?sprite'
import outros from '@/assets/icons/outros.svg?sprite'
import livroE from '@/assets/icons/livro_e.svg?sprite'

const iconsList = [{
  icon: reg,
  id: 1,
  iconId: reg.id,
},{
  icon: dnv,
  id: 2,
  iconId: dnv.id,
},{
  icon: obito,
  id: 3,
  iconId: obito.id,
},{
  icon: casamento,
  id: 4,
  iconId: casamento.id,
},{
  icon: maternidade,
  id: 5,
  iconId: maternidade.id,
},{
  icon: outros,
  id: 6,
  iconId: outros.id,
}]

export default iconsList
